import React, { createRef } from 'react';
import { IonAlert, IonChip, IonButton, IonTextarea, IonInput, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonText } from '@ionic/react';
import '../styles/FlashcardEditorModal.scss';
import '../styles/ImagePreviewModal.scss';
import Storage from '../Storage';
import Utilities from '../Utilities';
import SQLStorage from '../SQLStorage';
import Drawer from '@material-ui/core/Drawer';
import TagEditorModal from './TagEditorModal';
import { closeCircle, bookOutline, checkmarkDoneOutline, open, checkmarkOutline, book, star, eye, image, arrowDownOutline, trash, trendingUp, checkmark, checkmarkCircle, play, playOutline, sync, playCircle, checkmarkDoneCircle, school, albums, notifications, logIn, logOut, refresh, layers, flash, pricetag, create, ellipsisHorizontal, closeOutline, close, attach, bookmark, bookmarks, link, text } from 'ionicons/icons';

import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';

import { isPlatform } from '@ionic/react';
import { SwipeableDrawer } from '@material-ui/core';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import InnerImageZoom from 'react-inner-image-zoom';

import { Browser } from '@capacitor/browser';

class ImagePreviewModal extends React.Component {

   constructor(props) {
        super(props);
        this.modalRef = createRef();
        this.state = {
            status: "loading"
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.url !== this.props.url) {
            this.setState({
                status: "loading"
            });
            if (nextProps.cardId && nextProps.url) {
                Utilities.trackEvent("Flashcard", "Flashcard Image Show", this.props.cardId);
                new Promise( async (resolve) => {
                    if (window.os !== "web") {
                        let linkBase64 = await Utilities.getImage(nextProps.cardId, nextProps.url, false, "-", true, true);
                        if (linkBase64) {
                            this.setState({
                                link: linkBase64,
                                status: null
                            })
                        } else {
                            Utilities.onDrawerHide();
                            this.props.onClose();
                        }
                    } else {
                        this.setState({
                            link: nextProps.url,
                            status: null
                        })
                    }
                })
            } else {
                this.setState({ status: null, link: null })
            }
        }
    }

    render() {

        return (
            <SwipeableDrawer
               anchor="bottom"
               open={this.props.open !== null && this.props.open !== undefined && this.props.open !== ""}
               key="image-preview"
               onClose={ () => {
                    Utilities.onDrawerHide();
                    this.props.onClose();
               } }
               onOpen={ () => {
                   Utilities.onDrawerShow();
               } }
           >
                { (this.props.open !== null && this.props.open !== undefined && this.props.open !== "") &&
                   <div ref={this.modalRef} data-drawer="flashcard-editor" className="flashcard-editor-modal image-preview-modal">
                        <div className="drag-indicator"></div>
                        <div className="drag-close-indicator" onClick={() => {
                            Utilities.onDrawerHide();
                            this.props.onClose(true);
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>

                       <div 
                            className="image"
                            style={{
                                background: this.state.status !== "loaded" ? '#4D80E4' : undefined
                            }}
                        >
                            { (this.state.link) &&
                                <InnerImageZoom src={this.state.link} zoomSrc={this.state.link} zoomScale={1} fullscreenOnMobile={true} />
                            }
                            {/* { (window.os === "web") ?
                                <img 
                                    src={this.props.url}
                                    onError={() => { 
                                        this.setState({ status: "error" });
                                        window.toast(window.ln.failedImageLoad, "error");
                                        this.props.onClose();
                                    }}
                                    onLoad={() => { this.setState({ status: "loaded" }) }}
                                />
                                :
                                null
                            } */}
                            { (this.state.status === "loading") &&
                                <div className="spinner-wrapper">
                                    <svg className="spinner" viewBox="0 0 50 50">
                                        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                    </svg>
                                </div>
                            }
                       </div>
                       <section className="edit">
                            <div className="opts">
                                <div className="left">
                                    { (this.props.allowDelete) &&
                                        <button onClick={() => {
                                            this.props.onDelete();
                                        }}>
                                            <IonIcon icon={trash} />
                                        </button>
                                    }
                                    <button onClick={() => {
                                        Utilities.trackEvent("Flashcard", "Flashcard Image Open", this.props.cardId);
                                        Browser.open({ url: this.props.url });
                                    }}>
                                        <IonIcon icon={open} />
                                    </button>
                                    <button 
                                        onClick={() => {
                                            this.props.onClose();
                                        }}
                                        style={{
                                            flexBasis: this.props.allowDelete ? 'calc(100% - 108px)' : 'calc(100% - 54px)'
                                        }}
                                    >
                                        <IonIcon icon={closeCircle} />
                                        <span>{window.ln.close}</span>
                                    </button>
                                </div>
                            </div>
                        </section>
                   </div>
                }
                
           </SwipeableDrawer>
        );
    }

};


export default withIonLifeCycle(ImagePreviewModal);
